import React from "react";
import { motion } from "framer-motion";
import { BRANDS as BRAND_IDS } from "@/constants/testIds";
import { useT } from "@/i18n/LanguageContext";
import {
  FADE_UP_INITIAL,
  FADE_UP_ANIMATE,
  VIEWPORT_ONCE,
} from "./animations";

// Deck pages gallery — everything from index 1 onwards (index 0 is featured
// on the hero band). Grid becomes single-column when only one extra page.
export default function BrandDeck({ brand, gallery }) {
  const { t } = useT();
  return (
    <section className="bg-white">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16 lg:py-24">
        <div className="flex items-baseline justify-between gap-6 mb-10">
          <p className="overline" style={{ color: brand.palette.accent }}>
            {t("brandPage.fromDeck", { name: brand.name })}
          </p>
          <p className="text-xs font-semibold uppercase tracking-widest text-neutral-400">
            {String(gallery.length + 1).padStart(2, "0")} {t("brandPage.pages")}
          </p>
        </div>
        <div className="grid gap-8 md:gap-10 md:grid-cols-2">
          {gallery.map((src, i) => (
            <motion.div
              key={src}
              initial={FADE_UP_INITIAL}
              whileInView={FADE_UP_ANIMATE}
              viewport={VIEWPORT_ONCE}
              transition={{ duration: 0.7, delay: i * 0.05 }}
              className={`overflow-hidden rounded-3xl shadow-xl border border-neutral-100 ${
                gallery.length === 1 ? "md:col-span-2" : ""
              }`}
            >
              <img
                src={src}
                alt={`${brand.name} presentation page ${i + 2}`}
                data-testid={BRAND_IDS.deckImage(brand.slug, i + 1)}
                className="w-full h-auto object-contain block"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
